import React, { useState, useEffect, useContext, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import Context from './GrievancesModuleContext';
import grievanceService from '../../services/grievanceService';
import { SpinnerArea } from '../../shared/components';
import MainContext from '../App/MainProvider/context';

export const GrievancesModuleContextProvider: React.FC<{
  children: React.ReactNode;
  grievanceNumber?: string;
  formAccess?: boolean;
}> = ({ children, grievanceNumber, formAccess }) => {
  const { notify, inSuperUserMode } = useContext(MainContext);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [hasAccess, setHasAccess] = useState<boolean | undefined>(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    grievanceService
      .checkAccessToGrievances(grievanceNumber, formAccess)
      .then((granted) => {
        if (!granted) {
          notify(
            t('Error'),
            t('youDoNotHavePermissionToPerformThisAction'),
            'danger',
            'exclamation-triangle'
          );
          navigate('/');
        }

        setHasAccess(granted);
      })
      .catch(() => {
        notify(
          t('Error'),
          t('youDoNotHavePermissionToPerformThisAction'),
          'danger',
          'exclamation-triangle'
        );
        navigate('/');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [grievanceNumber, inSuperUserMode]);

  const value = useMemo(() => ({ grievanceNumber }), [grievanceNumber]);

  return (
    <Context.Provider value={value}>
      <SpinnerArea loading={loading}>{hasAccess && children}</SpinnerArea>
    </Context.Provider>
  );
};

export default GrievancesModuleContextProvider;
